import React from "react";
import {
  Modal,
  Form,
  Button,
} from "react-bootstrap";

export default function EditPayrollModal({
  show,
  handleClose,
  selectedItem,
}) {

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Payroll</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>

            <Form.Control
              defaultValue={selectedItem?.name}
            />
          </Form.Group>

          <Button className="save-btn w-100">
            Update
          </Button>

        </Form>

      </Modal.Body>
    </Modal>
  );
}